<template>
  <div>
    <a-modal v-model="visible" title="注意" @ok="playVoice" @cancel="playVoice">
      <p>本网站会播放声音,请注意音量</p>
    </a-modal>
<!--        <video id="video" style="height: 100%;width: 100%;position: absolute;left: 0;top: 0;z-index: -99; object-fit: cover"-->
<!--               src="../assets/luckdraw.mp4" loop type="video/mp4" muted></video>-->
    <video id="video" style="height: 100%;width: 100%;position: absolute;left: 0;top: 0;z-index: -99; object-fit: cover"
           src="/rs/luckdraw.mp4" autoplay loop type="video/mp4" muted></video>

    <div id="div1">
        <span>
        <h2>员工姓名:{{ name }}</h2>
        <h2>员工部门:{{ dept }}</h2>
        <h2>员工编号:{{ number }}</h2>
        </span>
    </div>
    <div id="div2">
      <a-button id="start1" type="primary" @click="start1">开始</a-button>
      <a-button id="stop1" type="danger" @click="stop1">停止</a-button>
    </div>


    <!--    <div class="gutter-example">-->
    <!--      <a-row>-->
    <!--        <a-col class="gutter-row" :span="1" v-for="(item,index) in list">-->
    <!--                    <div class="gutter-box" :id="index" style="font-weight: bold;font-size: 20px">{{ index }}</div>-->
    <!--          <div class="gutter-box" :id="index" style="font-weight: bold;font-size: 20px">&nbsp;</div>-->
    <!--          <div class="gutter-box" :id="index" style="font-weight: bold;font-size: 20px;color: white">{{item.name}}</div>-->
    <!--        </a-col>-->
    <!--      </a-row>-->
    <!--    </div>-->
    <!--    <div>-->
    <!--      <a-button type="primary" @click="start1">开始</a-button>-->
    <!--      <a-button type="danger" @click="stop1">停止</a-button>-->
    <!--      <a-button type="primary" @click="startn(2)">生成两个</a-button>-->
    <!--      <a-button type="primary" @click="startn(5)">生成五个</a-button>-->
    <!--      <a-button type="primary" @click="startn(10)">生成十个</a-button>-->
    <!--    </div>-->

    <!--    <a-modal v-model:visible="visible1" :maskClosable=false>-->
    <!--      <p class="font">部门:{{ dept }}</p>-->
    <!--      <p class="font">姓名:{{ name }}</p>-->
    <!--      <p class="font">员工编号:{{ number }}</p>-->
    <!--      <template #footer>-->
    <!--        <a-button key="back" @click="handleOk">确认</a-button>-->
    <!--      </template>-->
    <!--    </a-modal>-->
    <!--    <a-modal v-model:visible="visiblen" :maskClosable=false>-->
    <!--      <p class="font" style="white-space: pre-line">{{ message }}</p>-->
    <!--      <template #footer>-->
    <!--        <a-button key="back" @click="stopn">确认</a-button>-->
    <!--      </template>-->
    <!--    </a-modal>-->

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "luckDraw",
  data() {
    return {
      count:0,
      visible: true,
      timer: "",
      flag: false,
      name: "",
      dept: "",
      number: "",
      visible1: false,
      message: "",
      visiblen: false,
      selected: 0,
      lastSelected: -1,
      list: [],
    };
  },
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/test/readExcel")
      // axios.get("http://172.16.70.11:9000/test/readExcel")
      .then((res) => {
        this.list = res.data.data;
        if (this.list.length == 0) {
          alert("数据读取失败");
        }
      });
    let videoElement = document.getElementById("video");
    window.onfocus = function () {
      if (videoElement.muted == true) {
        videoElement.muted = false;
      }
      // videoElement.play();
    };
    window.onblur = function () {
      if (videoElement.muted == false) {
        videoElement.muted = true;
      }
      // videoElement.pause();
    };
  },
  methods: {
    playVoice() {
      this.visible = false;
      let videoElement = document.getElementById("video");
      if (videoElement.muted == true) {
        videoElement.muted = false;
      }
      videoElement.play();
    },
    start1() {
      if (this.list.length < 1) {
        alert("剩余数量小于1");
        return;
      }
      if (!this.flag) {
        this.timer = window.setInterval(() => {
          // let lastDiv = document.getElementById(this.lastSelected);
          // if (lastDiv != null && lastDiv.className == "selected") {
          //   lastDiv.className = "gutter-box";
          // }
          this.selected = Math.floor(Math.random() * this.list.length);
          if(this.count>=90){
            while(true){
              if(this.list[this.selected].regular=="否"){
                this.selected = Math.floor(Math.random() * this.list.length);
              }else{
                break;
              }
            }
          }
          this.name = this.list[this.selected].name;
          this.dept = this.list[this.selected].dept;
          this.number = this.list[this.selected].number;
          // this.lastSelected = this.selected;
          // let div = document.getElementById(this.selected);
          // if (div != null && div.className == "gutter-box") {
          //   div.className = "selected";
          // }
        }, 50);
        this.flag = true;
      }
    },
    stop1() {
      if (this.flag) {
        this.flag = false;
        this.count++;
        window.clearInterval(this.timer)
        this.list.splice(this.selected, 1);
        // setInterval(function () {
        // }, 50)
        // this.name = this.list[this.selected].name;
        // this.dept = this.list[this.selected].dept;
        // this.number = this.list[this.selected].number;
        // this.visible1 = true;
      }
    },
    handleOk() {
      this.list.splice(this.selected, 1);
      this.visible1 = false;
    },
    startn(count) {
      if (count > this.list.length) {
        alert("生成数量大于剩余总数");
        return;
      }
      for (let i = 0; i < count; i++) {
        let temp = Math.floor(Math.random() * this.list.length);
        this.message = this.message + this.list[temp].name + "\t" + this.list[temp].dept + " \t" + this.list[temp].number + " \r\n";
        this.list.splice(temp, 1);
      }
      this.visiblen = true;
    },
    stopn() {
      this.visiblen = false;
      this.message = "";
    }
  },

}
</script>

<style scoped>
.gutter-example {
  background: transparent;
  border: 0;
}

.gutter-box {
  background: #00000000;
  padding: 5px 0;
}

.selected {
  background: #00a0e9ff;
  padding: 5px 0;
}


.font {
  font-size: larger;
  color: #ffffff;
}

/*/deep/ .ant-modal-body {*/
/*  background-color: #ff0000;*/
/*}*/

/*/deep/ .ant-modal-footer {*/
/*  background-color: #ff0000;*/
/*}*/
#div1 {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: -20%;
  margin: auto;
  width: 600px;
  height: 300px;
  overflow: hidden;
  /*使伪类元素flex布局*/
  display: flex;
  /*左右居中*/
  justify-content: center;
  /*所有的子元素居中*/
  align-items: center;
  background: #000000;
  border-radius: 12px;
}

#div1::after {
  content: "";
  width: 1000px;
  height: 1000px;
  position: absolute;
  background-image: conic-gradient(transparent, transparent, transparent, red);
  animation: animate 4s infinite linear;
}

#div1::before {
  content: "";
  width: 1000px;
  height: 1000px;
  position: absolute;
  transform: rotate(180deg);
  background-image: conic-gradient(transparent, transparent, transparent, red);
  animation: animate 4s infinite linear;
  animation-delay: -2s;
}

#div1 span {
  position: relative;
  margin: 0 auto;
  background: #000000;
  z-index: 12;
  width: 590px;
  height: 290px;
  border-radius: 12px;
}

#div1 h2 {
  color: #fff;
  line-height: 80px;
  text-align: center;
  font-size: 3em;
}


@keyframes animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

#div2 {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 30%;
  margin: auto;
  width: 600px;
  height: auto;
  overflow: hidden;
  /*使伪类元素flex布局*/
  display: flex;
  /*左右居中*/
  justify-content: center;
  /*所有的子元素居中*/
  align-items: center;
}

#start1 {
  width: 250px;
  height: 100px;
  margin-right: 100px;
  font-size: 3em;
}

#stop1 {
  width: 250px;
  height: 100px;
  font-size: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/LuckDraw.vue